import { render, staticRenderFns } from "./waitConfirmOrders.vue?vue&type=template&id=9dbcf814&scoped=true"
import script from "./waitConfirmOrders.vue?vue&type=script&lang=js"
export * from "./waitConfirmOrders.vue?vue&type=script&lang=js"
import style0 from "./waitConfirmOrders.vue?vue&type=style&index=0&id=9dbcf814&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dbcf814",
  null
  
)

export default component.exports